import { FormGroup } from '@angular/forms';
import { InjectionToken } from '@angular/core';
import {
    RpaDto,
    DisplayableMissionDto,
    InUseMissionWorkflowVersionDto,
    LocationDetailsDto
} from '@flyfreely-portal-ui/flyfreely';
import { MissionFormModel } from 'libs/missions/src/lib/interfaces';
import { Observable } from 'rxjs';

/**
 * The data contract that a mission edit service must satisfy in order to drive
 * `AirspaceCheckService` in reactive (mission-editor) mode.
 *
 * Provided at component scope by the mission editor via:
 * ```ts
 * { provide: MISSION_EDIT_INPUTS, useExisting: MissionEditService }
 * ```
 *
 * `AirspaceCheckService` injects this with `@Optional()`, so screens that do
 * not host the mission editor (details, approval) simply omit the provider and
 * the check service falls back to `startSingleCheck`.
 */
export interface IMissionEditInputs {
    missionDate$: Observable<Date>;
    missionLocation$: Observable<LocationDetailsDto>;
    rpas$: Observable<RpaDto[]>;
    missionWorkflows$: Observable<InUseMissionWorkflowVersionDto[]>;
    loadingWorkflow$: Observable<boolean>;
    savedMission$: Observable<DisplayableMissionDto>;

    missionForm: FormGroup<MissionFormModel>;
    organisationId: number;
    missionId: number | undefined;
}

/**
 * Angular injection token for the mission edit inputs contract.
 * Use this instead of `AirspaceMissionEditService` in `providers` arrays and
 * `@Inject()` decorators.
 */
export const MISSION_EDIT_INPUTS = new InjectionToken<IMissionEditInputs>(
    'MissionEditInputs'
);

/**
 * @deprecated Use `MISSION_EDIT_INPUTS` InjectionToken and `IMissionEditInputs`
 * interface instead.  This class-as-token pattern will be removed in a future
 * cleanup pass.
 */
export class AirspaceMissionEditService implements IMissionEditInputs {
    missionDate$: Observable<Date>;
    missionLocation$: Observable<LocationDetailsDto>;
    rpas$: Observable<RpaDto[]>;
    missionWorkflows$: Observable<InUseMissionWorkflowVersionDto[]>;
    loadingWorkflow$: Observable<boolean>;
    savedMission$: Observable<DisplayableMissionDto>;

    missionForm: FormGroup<MissionFormModel>;
    organisationId: number;
    missionId: number | undefined;
}
